const PERSONAL_DOMAINS = new Set([
  'gmail.com',
  'googlemail.com',
  'yahoo.com',
  'yahoo.co.in',
  'hotmail.com',
  'outlook.com',
  'live.com',
  'msn.com',
  'icloud.com',
  'me.com',
  'protonmail.com',
  'proton.me',
  'aol.com',
  'mail.com',
  'gmx.com',
  'yandex.com',
  'ymail.com',
  'rediffmail.com',
  'inbox.com',
  'zoho.com',
]);

export function domainOf(email) {
  const s = String(email || '').toLowerCase().trim();
  const at = s.lastIndexOf('@');
  if (at <= 0) return '';
  return s.slice(at + 1);
}

export function looksLikeCompleteEmail(email) {
  const s = String(email || '').trim();
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s);
}

export function isLikelyPersonalEmail(email) {
  if (!looksLikeCompleteEmail(email)) return false;
  return PERSONAL_DOMAINS.has(domainOf(email));
}

export function isLikelyProfessionalEmail(email) {
  if (!looksLikeCompleteEmail(email)) return false;
  const d = domainOf(email);
  if (!/^[\w.-]+\.[a-z]{2,}$/i.test(d)) return false;
  return !PERSONAL_DOMAINS.has(d);
}
